import { MOTOR_IMAGE_PLACEHOLDER } from './lib'
import { AirMotor } from './types'

interface MotorImageResponse {
  thumbnail: string
  // Add other fields if needed in the future
}

const REDPIM_API_BASE = process.env.REACT_APP_REDPIM_API_BASE ?? ''
const REDPIM_API_KEY = process.env.REACT_APP_REDPIM_API_KEY ?? ''

export const fetchMotorImage = async (productNumber: string): Promise<string> => {
  try {
    const response = await fetch(`${REDPIM_API_BASE}/cp/items/${productNumber}`, {
      headers: {
        'X-Api-Key': REDPIM_API_KEY,
      },
    })
    if (!response.ok) {
      throw new Error('Failed to fetch motor image')
    }
    const data: MotorImageResponse = await response.json()
    // Append the required suffix to the thumbnail URL
    return data.thumbnail + '/jcr:content/renditions/cq5dam.web.800.800.jpeg'
  } catch (error) {
    console.error('Error fetching motor image:', error)
    return MOTOR_IMAGE_PLACEHOLDER
  }
} 